import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { AccessTokenService } from './access-token.service';
import { DynamicDataService } from './dynamic-data.service';

/**
 * Variance Analysis has no sidebar entry — it's a deep-link reached from a
 * savings item. Tenant gate lives on the SavingsTrackerList tblPageFields row
 * `sectionVarianceAnalysis`. Cache is normally populated when the parent list
 * renders; for direct-URL entry (bookmark, refresh on this route) fall back to
 * an on-demand fetch so the guard still resolves.
 */
export const varianceAnalysisGuard: CanActivateFn = async () => {
  const dyn = inject(DynamicDataService);
  const token = inject(AccessTokenService);
  const router = inject(Router);

  let data = dyn.getDataFromLocal('SavingsTrackerList');
  if (!Array.isArray(data)) {
    try {
      const resp: any = await firstValueFrom(
        dyn.getPageData({ UserID: token.getUserId(), pageName: 'SavingsTrackerList' }),
      );
      if (resp?.status === 'success' && Array.isArray(resp.data)) {
        data = resp.data;
        dyn.setDataToLocal('SavingsTrackerList', data);
      }
    } catch {
      // Fall through — the isPageActive check below will default-deny to
      // /dashboard so a failing / hanging getPageData never strands the user
      // on a blank route.
    }
  }
  if (dyn.getStatusFieldName('sectionVarianceAnalysis', data as any)) return true;
  router.navigateByUrl('dashboard');
  return false;
};
